import React from 'react';
import { useParams } from '@common/hooks';
import { AppContent } from '@common/components';
import { CandidateAssignment } from 'works/components/candidate-assignment';
import { WorkerDetail } from '@scheduling/components';

export function AssignmentPage() {
  const { id, type, resourceId } = useParams();

  const selectComponent = () => {
    if (type === 'on_demand' && resourceId) {
      return <CandidateAssignment staffingRequestAssignmentId={resourceId} />;
    } else if (type === 'on_demand') {
      return <WorkerDetail workerId={id} />;
    } else {
      return <CandidateAssignment staffingRequestAssignmentId={id} />;
    }
  };

  return <AppContent>{selectComponent()}</AppContent>;
}
